export function bundleDiscountRate(quantity) {
  const qualifyingQuantity = Number(quantity);
  if (qualifyingQuantity >= 4) return 0.20;
  if (qualifyingQuantity === 3) return 0.15;
  if (qualifyingQuantity === 2) return 0.10;
  return 0;
}

export function estimateWallArtBundle(items) {
  const wallArtItems = items.filter((item) => item.isWallArt);
  const qualifyingQuantity = wallArtItems.reduce(
    (total, item) => total + Number(item.quantity || 0),
    0,
  );
  const wallArtSubtotal = wallArtItems.reduce(
    (total, item) => total + Number(item.finalLinePrice || 0),
    0,
  );
  const rate = bundleDiscountRate(qualifyingQuantity);

  return {
    qualifyingQuantity,
    wallArtSubtotal,
    rate,
    savings: Math.round(wallArtSubtotal * rate),
  };
}

const discountCodeButtons = new WeakSet();
const MANUAL_CODE_MARKER = 'hewn-cart-manual-discount-code';

export async function initialiseCartDiscountCode(
  root,
  {
    fetchCart = (...args) => fetch(...args),
    reload = () => window.location.reload(),
    cartRoot = () => window.Shopify?.routes?.root ?? '/',
    session = typeof window !== 'undefined' ? window.sessionStorage : null,
  } = {},
) {
  const input = root.querySelector('[data-cart-discount-code]');
  const button = root.querySelector('[data-cart-discount-apply]');
  const status = root.querySelector('[data-cart-discount-status]');

  if (!input || !button || discountCodeButtons.has(button)) return;

  discountCodeButtons.add(button);
  if (!session?.getItem(MANUAL_CODE_MARKER)) {
    try {
      const response = await fetchCart(`${cartRoot()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'The preloaded discount could not be removed.');
      session?.setItem(MANUAL_CODE_MARKER, 'cleared');
      reload();
      return;
    } catch (error) {
      if (status) status.textContent = error.message || 'The preloaded discount could not be removed.';
    }
  }
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    const code = input.value.trim();
    if (!code) return;
    button.disabled = true;
    if (status) status.textContent = 'Applying discount…';
    try {
      session?.setItem(MANUAL_CODE_MARKER, 'applied');
      const response = await fetchCart(`${cartRoot()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'That discount code could not be applied.');
      reload();
    } catch (error) {
      if (status) status.textContent = error.message || 'That discount code could not be applied.';
      button.disabled = false;
    }
  });
}

function initialiseCartDiscountCodes() {
  document.querySelectorAll('[data-cart]').forEach((root) => {
    initialiseCartDiscountCode(root);
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCartDiscountCodes);
  } else {
    initialiseCartDiscountCodes();
  }
}
